export const enterUsernameStyles = {
  container: {
    width: {
      xs: '100%',
      sm: '400px',
    },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'baseline',
    gap: '24px',
    paddingBottom: '50px',
  },
  checkbox: {
    '& path': {
      color: 'inherit',
    },
    '& span': {
      fontWeight: 400,
    },
  },
  buttonWrapper: {
    width: '100%',
    textDecoration: 'none',
  },
  button: {
    width: '100%',
  },
  textLinkSx: {
    marginBottom: '40px',
  },
};
